import './style.scss'
import FormButton from "../../generic/buttons/main";
import Field from "../../generic/Field";
import {t} from "i18next";
import {datetimeToDate} from "../../../lib/utils/format";
import {useState} from "react";
import {useCaptcha} from "../../../lib/utils/hooks/useCaptcha";
import {usePublicEndpoints} from "../../../lib/api/usePublicEndpoints";

const SearchCertificate = ({ certificateInfo, generateCaptcha, certificate, setCertificate }) => {
    return (
        <div className="certificates-saved">
            <Field
                label={t('profile.certificatesSubscriptions.certificateLabel')}
                value={certificate || ''}
                setValue={setCertificate}
                placeholder="xxxx-xxxx-xxxx"
                fieldName="certificate"
                className="field"
                error={certificateInfo.status !== 'Found'}
            />
            {certificate &&
                <FormButton value={t('profile.certificatesSubscriptions.check')} className="personal-button"
                            onClick={() => generateCaptcha()}
                            disabled={!certificate.trim()}/>
            }
            <div className="certificates__actions">
                <p>{t('profile.certificatesSubscriptions.giveExperience')}</p>
                <div className="certificates__buttons">
                    <FormButton
                        value={t('profile.certificatesSubscriptions.buy')}
                        type="button"
                        className="small-button"
                        onClick={() => window.location.href = '/certificate'}
                    />
                    <FormButton
                        value={t('profile.certificatesSubscriptions.more')}
                        type="button"
                        className="small-button"
                        color={'white'}
                        onClick={() => window.location.href = t('profile.certificatesSubscriptions.moreCertificateLink')}
                    />
                </div>
            </div>

            <div className="sertificate_info">
                {certificateInfo.status === 'Not Found' &&
                    <div className="sertificate_info_item is_error">
                        {t('profile.certificatesSubscriptions.certificateNotFound')}
                    </div>
                }
                {certificateInfo.status === 'Not Available' &&
                    <div className="sertificate_info_item">
                        {t('profile.certificatesSubscriptions.certificateNotAvailable')}
                    </div>
                }
                {certificateInfo.sum &&
                    <div className="sertificate_info_item">
                        {t('profile.certificatesSubscriptions.certificateBalance')}:&nbsp;
                        <span>{certificateInfo.sum}</span>
                    </div>
                }
                {certificateInfo.productTypes &&
                    <div className="sertificate_info_item">
                        {t('profile.certificatesSubscriptions.certificateApplies')}:&nbsp;
                        <span>{certificateInfo.productTypes}</span>
                    </div>
                }
                {certificateInfo.country &&
                    <div className="sertificate_info_item">
                        {t('profile.certificatesSubscriptions.certificateCountry')}:&nbsp;
                        <span>{certificateInfo.country}</span>
                    </div>
                }
                {certificateInfo.availableTo &&
                    <div className="sertificate_info_item">
                        {t('profile.certificatesSubscriptions.certificateAvailableTo')}:&nbsp;
                        <span>{datetimeToDate(certificateInfo.availableTo)}</span>
                    </div>
                }
            </div>
        </div>
    )
}

const CertificatesProfile = () => {
    const [certificateInfo, setCertificateInfo] = useState({});
    const {getCertificateInfo} = usePublicEndpoints();
    const [certificate, setCertificate] = useState('');
    const clickCheckCertificateButton = async (captchaToken) => {
        const res = await getCertificateInfo(certificate, captchaToken);
        setCertificateInfo(res);
    }

    const [generateCaptcha, ReCAPTCHA] = useCaptcha(clickCheckCertificateButton);

    return (
        <>
            {ReCAPTCHA}
            <h1 className='profile-title'>{t('profile.certificates.blockTitle')}</h1>
            <SearchCertificate
                certificateInfo={certificateInfo}
                generateCaptcha={generateCaptcha}
                certificate={certificate}
                setCertificate={setCertificate}
            />
        </>
    )
}

export default CertificatesProfile;